import QRious from 'qrious';
export const LEVELS = ['L', 'M', 'Q', 'H'];
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
        background: String,
        backgroundAlpha: Number,
        foreground: String,
        foregroundAlpha: Number,
        level: {
            type: String,
            validator: (level) => LEVELS.includes(level),
        },
        mime: String,
        padding: Number,
        size: Number,
    },
    data() {
        const qrious = new QRious(this.$props);
        return {
            qrious,
            dataUrl: qrious.toDataURL(this.mime),
        };
    },
    watch: {
        $props: {
            deep: true,
            handler() {
                this.qrious.set(this.$props);
                this.dataUrl = this.qrious.toDataURL(this.mime);
            },
        },
    },
    render() {
        return this.$createElement('img', {
            domProps: Object.assign(Object.assign({}, this.$attrs), { src: this.dataUrl }),
        });
    },
};
//# sourceMappingURL=index.js.map